import { themeUi } from '../../themeUi/themeUi';

const sectionCard = {
  boxShadow: themeUi.core.shadow.shadow4
};

export default sectionCard;
